import React, { Component } from 'react';
import Header from '../components/header';
import Footer from '../components/footer';
import Comment from '../components/wiki/comment'
import blogAPI from '../api/blog'

export default class EncyclopediaPost extends Component {

    state = {
        postData: {},
    }

    loadPost = (postID) => {
        const blogAPIObj = new blogAPI()
        blogAPIObj.getPostDetail(postID).then((response) => {
            if (response.success) {
                this.setState({ postData: response.data })
                document.title = response.data.title
            } else {
                this.props.context.history.push('/wiki');
            }
        })
    }

    componentDidMount() {
        if (this.props.context.match.params.postID) {
            this.loadPost(this.props.context.match.params.postID)
            document.title = this.props.texts["encyclopediaTitle"]
        } else {
            this.props.context.history.push('/wiki');
        }
    }

    render() {
        return (
            <div className="post-page">
                <Header />
                <div className="search-bar">
                    {/* middle image */}
                    {/* <img className="best-cover" src="/static/img/best-rugs.png" alt="cover-page" /> */}
                </div>
                {/* detail post */}
                <div className="detail-post pb-5 mb-5">
                    <div className="container pt-3 mb-3">
                        <div className="row pt-3 pb-4">
                            <div className="col-lg-10 col-md-10 col-sm-12 col-xs-12 description-post">
                                <h2 className="mb-4">{this.state.postData.title}</h2>
                                <div className="mb-3" dangerouslySetInnerHTML={{ __html: this.state.postData.body }}></div>
                            </div>
                            {/* <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 image-post">
                                <img className="big-image" src="/static/img/post-image.png" alt="post-image" />
                                <ul className="little-list-image">
                                    <li>
                                        <img src="/static/img/post23.png" alt="image" />
                                    </li>
                                    <li>
                                        <img src="/static/img/post24.png" alt="image" />
                                    </li>
                                    <li>
                                        <img src="/static/img/post25.png" alt="image" />
                                    </li>
                                    <li>
                                        <img src="/static/img/post23.png" alt="image" />
                                    </li>
                                    <li>
                                        <img src="/static/img/post24.png" alt="image" />
                                    </li>
                                    <li>
                                        <img src="/static/img/post25.png" alt="image" />
                                    </li>
                                </ul>
                            </div> */}
                        </div>
                        {/* comment start */}
                        <Comment />
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}